import { Deserialize, inheritSerialization } from 'cerialize';
import { ApprovalObjectStatus } from './approval-object-status';
import { ClientFeeSchedule } from './client-fee-schedule';

@inheritSerialization(ApprovalObjectStatus)
export class ClientFeeScheduleApprovalStatus extends ApprovalObjectStatus {
  get clientFeeSchedule(): ClientFeeSchedule {
    return Deserialize(this.object, ClientFeeSchedule);
  }
}
